import commonUtil from '../../../utils/commonUtil';

export const ALL_CATEGORIES_LOAD = 'ALL_CATEGORIES_LOAD';
export const ALL_CATEGORIES_LOAD_SUCCESS = 'ALL_CATEGORIES_LOAD_SUCCESS';
export const ALL_CATEGORIES_LOAD_FAIL = 'ALL_CATEGORIES_LOAD_FAIL';
export const LINKS_MENU_LOAD = 'LINKS_MENU_LOAD';
export const LINKS_MENU_LOAD_SUCCESS = 'LINKS_MENU_LOAD_SUCCESS';
export const LINKS_MENU_LOAD_FAIL = 'LINKS_MENU_LOAD_FAIL';

export function loadAllCategoriesData(globalState) {
  return globalState.megaMenuData && globalState.megaMenuData.loaded;
}

export function getAllCategoriesData() {
  const userEnteredData = {};
  userEnteredData.brandName = commonUtil.getBrand().toUpperCase();
  userEnteredData.channel = commonUtil.getChannel().toUpperCase();
  return {
    types: [ALL_CATEGORIES_LOAD, ALL_CATEGORIES_LOAD_SUCCESS, ALL_CATEGORIES_LOAD_FAIL],
    promise: client => client.post('/api/category/getCategories', {
      data: (userEnteredData),
    }),
  };
}

export function loadLinksData(globalState) {
  return globalState.linksMenuData && globalState.linksMenuData.loaded;
}

export function getLinksMenuData() {
  const requiredData = {};
  requiredData.brandName = commonUtil.getBrand().toUpperCase();
  requiredData.channel = 'WEB';
  return {
    types: [LINKS_MENU_LOAD, LINKS_MENU_LOAD_SUCCESS, LINKS_MENU_LOAD_FAIL],
    promise: client => client.post('/api/linksMenu', {
      data: (requiredData),
    }),
  };
}
